<script>
  import {
    createProps,
    getSchemaComponent,
    getSchemaComponentProps,
    defaultValue,
    getComponent,
    getComponentProps
  } from '../helpers'

  export let ui;

  const p = createProps({});
  export let value = p.value;
  export let errors = p.errors;
  export let schema = p.schema;
  export let components = p.components;
  export let key = p.key;
  /* recalc a default value */
  if (schema && value == null) {
      value = defaultValue(schema, value);
  }

  let position = -1;
  if (ui && ui["ui:order"])
    position = ui["ui:order"].findIndex(v => v == "*")
  function orderSort(a, b) {
    if (ui && ui["ui:order"]) {
      const aVal = ui["ui:order"].findIndex(v => v == a) == -1 ? position : ui["ui:order"].length - ui["ui:order"].findIndex(v => v == a);
      const bVal = ui["ui:order"].findIndex(v => v == b) == -1 ? position : ui["ui:order"].length - ui["ui:order"].findIndex(v => v == b);
      return bVal - aVal;
    }
    return a.toLowerCase().localeCompare(b.toLowerCase());
  }

  function getSchemaUi(key) {
    if (key) {
      if (ui && ui[key])
        return ui[key];
      else
        return null;
    }
    else {
      return ui;
    }
  }
</script>

{#if schema && components}
  <svelte:component
    this={getComponent(components.wrapper)}
    {...getComponentProps(components.wrapper)}
    {schema}
    {key}>
    {#each Object.keys(schema.properties).sort(orderSort) as key}
      <svelte:component
        this={getSchemaComponent(schema.properties[key], components)}
        props={getSchemaComponentProps(schema.properties[key], components)}
        {components}
        schema={schema.properties[key]}
        ui={getSchemaUi(key)}
        key={key}
        bind:value={value[key]}
        errors={errors && errors[key]} />
    {/each}
  </svelte:component>
{/if}
